"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutSpaceResolver = exports.PutSpace = exports.ServiceError = void 0;
const effect_1 = require("effect");
const HttpClientRequest = __importStar(require("@effect/platform/HttpClientRequest"));
class ServiceError extends effect_1.Data.TaggedError('@fixtuur/gavel/SpaceServiceError') {
}
exports.ServiceError = ServiceError;
class PutSpace extends effect_1.Request.TaggedClass('@fixtuur/gavel/PutSpaceRequest') {
}
exports.PutSpace = PutSpace;
const PutSpaceResolver = (http) => effect_1.RequestResolver.fromEffect(({ baseUrl, space, spaceId, token, tenant }) => (0, effect_1.pipe)(new URL(`/api/v1/${tenant}/spaces/${spaceId}`, baseUrl), HttpClientRequest.make('PUT'), HttpClientRequest.bearerToken(token), HttpClientRequest.bodyJson(space), effect_1.Effect.flatMap(http.execute), effect_1.Effect.flatMap(_ => effect_1.Effect.void), effect_1.Effect.mapError(originalError => new ServiceError({ originalError })), effect_1.Effect.scoped));
exports.PutSpaceResolver = PutSpaceResolver;
